<template>
    <div class="who-we-are-page">
        <IdSection :title="titleIdSection" :info="infoIdSection" />

        <section>
            <TextImgVideoSection
                :useImg="true"
                titleColor="yellow"
                :title="'Quem Somos'"
                :content="
                    `Somos uma plataforma para facilitar o <i><b>‘matching’, ou seja, o encontro e a conexão entre doadores e donatários!</b></i><br><br>
                    Por meio deste ambiente virtual buscamos reduzir a distância entre os investidores sociais e as iniciativas periféricas e contribuir para a qualificação da cultura de doação. Dessa maneira, fomentar para que mais doações e parcerias sejam direcionadas às periferias do Brasil</b><br><br>
                    Ela permite conhecer iniciativas que estão sendo realizadas, ajuda a identificar potenciais parceiros e investidores do campo social e também apresenta uma relação de prestadores de serviço que atuam na perspectiva da promoção da equidade<br><br>
                    Somos uma comunidade colaborativa, composta de potências e investidores, organizada em rede para fomentar o ecossistema de cultura sustentável das Potências Periféricas, e buscamos facilitar o 'matching', ou seja, o encontro e a conexão entre doadores e donatários para gerar oportunidades de trocas, de escambos, de conhecimentos, de facilitar acesso a recursos e aprendizados mútuos.<br><br>Chega junto,
                    é tudo nosso!`
                "
            />
        </section>

        <!-- <section>
            <TextImgVideoSection :useImg="true" :textFirst="false" titleColor="blue" />
        </section> -->
    </div>
</template>

<script>
import IdSection from '@//pages/public/components/landing-page/id-section/IdSection'
import TextImgVideoSection from '@/pages/public/components/landing-page/text-img-video-section/TextImgVideoSection'

export default {
    components: { IdSection, TextImgVideoSection },
    data() {
        return {
            titleIdSection: 'Quem somos',
            infoIdSection: `Somos uma plataforma para facilitar o ‘matching’, ou seja, o encontro e a conexão entre doadores e donatários!`
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/public/who-we-are-page/WhoWeArePage.vue